import styled from 'styled-components';

import Input from 'components/common/Input';

const FlatInputStyled = styled(Input)<{ $width?: string }>`
  background: transparent;
  border: none;
  border-radius: 0;
  padding: 0;
  color: ${({ theme }) => theme.colors.text.primary};
  border-bottom: 1px solid ${({ theme }) => theme.colors.text.subtle};
  width: ${({ $width }) => $width || '200px'};

  &::placeholder {
    font-weight: 300;
  }
`;

type FlatInputProps = {
  width?: string;
  [key: string]: any;
};

const FlatInput = ({ width, ...props }: FlatInputProps) => <FlatInputStyled {...props} $width={width} />;

export default FlatInput;
